module.exports = __webpack_public_path__ + "static/mobile_background-c3f000983aaee4ac9a8c6db35a600191.jpg";